import React from "react";
import { Checkbox } from "@atlaskit/checkbox";
import { Expandable } from "../Collapse/Expandable";
import { createKey } from "../../../helpers/helpers";

import styles from "./WrapperRestoreConfig.module.css";

export const TableWrapper = ({ children }) => (
  <div className={styles.tableWrapperStyles}>{children}</div>
);
export const NameWrapper = ({ children }) => (
  <span className={styles.nameWrapperStyles}>{children}</span>
);

export const AvatarWrapper = ({ children }) => (
  <div className={styles.avatarWrapperStyles}>{children}</div>
);

export const createHead = (
  withWidth,
  handleCheckboxCheckAllConfig,
  isLoading,
  globalCheckState
) => {
  return {
    cells: [
      {
        content: (
          <Checkbox
            isDisabled={globalCheckState.disabled || isLoading}
            isChecked={globalCheckState.allChecked}
            isIndeterminate={globalCheckState.indeterminate}
            value="All"
            name="parent"
            type="checkbox"
            onChange={(e) => handleCheckboxCheckAllConfig(e)}
          />
        ),
        key: "selectRow",
        isSortable: false,
        width: withWidth ? 10 : undefined,
      },
      {
        content: "Name",
        key: "name",
        isSortable: false,
        width: withWidth ? 80 : undefined,
      },
      {
        content: "Description",
        key: "description",
        isSortable: false,
        width: withWidth ? 120 : undefined,
      },
    ],
  };
};

export const createCells = (
  previewData,
  handleCheckboxCheckConfig,
  tempCheckedItems,
  checkedIssues
) =>
  previewData.map((data, index) => ({
    key: `row-${index}-${data.id}`,
    cells: [
      {
        key: createKey("selectRow"),
        content: (
          <Checkbox
            key={data.id}
            isDisabled={
              data.blockrestore === "false" ||
              (tempCheckedItems[data.id] !== true && checkedIssues.length > 49)
                ? true
                : false
            }
            isChecked={
              tempCheckedItems !== [] ? tempCheckedItems[data.id] : false
            }
            name={data.id}
            onChange={(e) => {
              handleCheckboxCheckConfig(e, data);
            }}
          />
        ),
      },
      {
        key: createKey(data.name),
        content: data.name,
      },
      {
        key: createKey("Description"),
        content: <Expandable description={data.description} />,
      },
    ],
  }));
